import React, { Fragment } from "react";
import { useFormikContext } from "formik";
import get from "lodash/get";
import cloneDeep from "lodash/cloneDeep";
import Button from "components/Form/fields/Button";
import { BUTTON_CLASS_CONTEXT } from "utils/constants/ui";
import MetadataList from "components/MetadataList";
import SectionBezel from "components/SectionBezel";
import { getTemplateStripeMetadata } from "utils/metadata";

const MetadataSection = ({ name }) => {
  const {
    values,
    touched,
    errors,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const error = get(errors, name);
  const metadata = get(values, name);
  const showError = Boolean(get(touched, name) && error);

  const actionControl = (
    <div className="flex flex-row">
      <Button
        theme="slim"
        classes={{
          contextClass: BUTTON_CLASS_CONTEXT.SECONDARY
        }}
        copy="Add"
        onClick={() => {
          const updatedValues = metadata ? cloneDeep(metadata) : {};
          updatedValues.push(getTemplateStripeMetadata());

          setFieldValue(name, updatedValues);
          !get(touched, name) && setFieldTouched(name, true);
        }}
      />
    </div>
  );

  return (
    <SectionBezel header="Metadata" action={actionControl}>
      <Fragment>
        <MetadataList name={name} />
        {showError}
      </Fragment>
    </SectionBezel>
  );
};

export default MetadataSection;
